import React, {Component} from 'react';
import {LanguageContext} from "../App";


class CustomMenu extends Component {
    render() {
        return (
            <LanguageContext.Consumer>
                {({language}) =>
                    <div id="customMenu">
                        <a href="https://edu-sense.com/pl?utm_source=puzzle&utm_medium=footer  ">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                 xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 viewBox="0 0 115 92" style={{"enableBackground": "new 0 0 115 92"}}
                                 xmlSpace="preserve">
                                <style type="text/css">
                                    {
                                        '.st0{fill:#FFFFFF;}'
                                    }
                                </style>
                                <path style={{"fill": "#00458a"}} className="st0" d="M102,57.9l11.7-37.5c0.4-1.1,0.1-2.4-0.6-3.3c-0.7-1-1.8-1.5-3-1.5H25.8L20.9,2.7c-0.6-1.5-1.9-2.4-3.5-2.4H3.6
	                                C1.5,0.3-0.2,2-0.2,4.1c0,2.1,1.7,3.8,3.8,3.8h11.2L34,57.9c0,0.1,0.1,0.2,0.1,0.4l4,10.5l-0.4,0.2c-4,2.1-6.5,6.1-6.5,10.6
	                                c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12c0-1.3-0.2-2.6-0.6-3.8l-0.2-0.7h26.9L81,75.8c-0.4,1.2-0.6,2.5-0.6,3.8c0,6.6,5.4,12,12,12
	                                c6.6,0,12-5.4,12-12c0-6.6-5.4-12-12-12H45.7L43,60.6h55.4C100.1,60.6,101.5,59.5,102,57.9z M92.3,75.1c2.5,0,4.4,2,4.4,4.4
	                                c0,2.5-2,4.5-4.4,4.5c-2.5,0-4.5-2-4.5-4.5C87.8,77.1,89.8,75.1,92.3,75.1z M43.1,75.1c2.5,0,4.4,2,4.4,4.4c0,2.5-2,4.5-4.4,4.5
	                                c-2.5,0-4.5-2-4.5-4.5C38.7,77.1,40.7,75.1,43.1,75.1z M40.2,53L28.7,23H105l-9.3,30H40.2z"/>
                            </svg>
                            <span className="icon_padding">{language['sklep']}</span>
                        </a>
                        <a href="https://akademia.uczymydzieciprogramowac.pl/pl?utm_source=puzzle&utm_medium=footer   ">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                 xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 viewBox="0 0 31 34.5" style={{"enableBackground": "new 0 0 31 34.5"}}
                                 xmlSpace="preserve">
                                <style type="text/css">
                                    {
                                        '.st0{fill:#FFFFFF}'
                                    }
                                </style>
                                <path style={{"fill": "#00458a"}} className="st0" d="M30,27.4L21.7,4.5c-1-2.9-2.3-4.3-6.3-4.3c-3.6,0-5.1,1.1-6.3,4.4L1,27.4c0,0,0,0.1,0,0.1
	                                c-0.2,0.7-0.4,1.4-0.4,2.2c0,2.7,2.1,4.7,4.9,4.7c2.4,0,4.1-1.3,4.8-3.6c0,0,0,0,0,0l0.9-2.8c2.6,0,5.9,0,8.5,0l0.9,2.8
	                                c1,3,3.2,3.6,4.8,3.6c2.2,0,4-1.2,4.7-3.2c0.2-0.5,0.2-1,0.2-1.5C30.4,28.9,30.2,28.2,30,27.4z M11,5.2c0.8-2.4,1.5-3.1,4.4-3.1
	                                c3,0,3.6,0.8,4.4,3l5.1,14.1c-0.2,0-0.5-0.1-0.7-0.1c0,0-2.3,0-5.2,0L15.4,8.4l0,0.1L12,19.2c-2.6,0-4.7,0-5.2,0
	                                c-0.3,0-0.5,0-0.7,0.1L11,5.2z M16.9,19.2c-0.9,0-1.9,0-2.8,0l1.4-4.3L16.9,19.2z M8.5,30.1C8.5,30.1,8.5,30.1,8.5,30.1
	                                C8,31.7,7,32.3,5.5,32.3c-1.8,0-2.9-1.1-2.9-2.7c0-0.5,0.1-1,0.3-1.5c0,0,0,0,0,0l0.6-1.8c0.7,1,1.9,1.7,3.2,1.7c0.4,0,1.3,0,2.4,0
	                                L8.5,30.1z M19,25.9h-7.1H9.8h-3c-1.1,0-2-1-2-2.3c0-1.3,0.9-2.3,2-2.3h4.5h2.1h4.1h2.1h4.6c1.1,0,2,1,2,2.3c0,1.3-0.9,2.3-2,2.3h-3
	                                H19z M28.2,30.6c-0.4,1.1-1.4,1.8-2.8,1.8c-1.5,0-2.4-0.7-2.9-2.2L21.8,28c1.4,0,2.4,0,2.4,0c1.3,0,2.5-0.7,3.2-1.7l0.7,1.8
	                                c0.2,0.5,0.3,1,0.3,1.6C28.3,30,28.3,30.3,28.2,30.6z"/>
                            </svg>
                            <span className="icon_padding"
                            >{language['akademia']}</span>
                        </a>
                    </div>
                }
            </LanguageContext.Consumer>
        )
    }
}

export default CustomMenu;



// WEBPACK FOOTER //
// ./src/WorkingSpace/CustomMenu.js